import { render, staticRenderFns } from "./CustomPopup.vue?vue&type=template&id=c60d1854&scoped=true"
import script from "./CustomPopup.vue?vue&type=script&lang=js"
export * from "./CustomPopup.vue?vue&type=script&lang=js"
import style0 from "./CustomPopup.vue?vue&type=style&index=0&id=c60d1854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60d1854",
  null
  
)

export default component.exports